import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import trailingSlashIt from 'trailing-slash-it';
import Breadcrumbs from 'marketing/components/breadcrumbs';

const mapStateToProps = (_, { landingPage, params, location }) => {
  let items = [];

  /* handle landing pages with more than 1 path parts */
  let parentUrl = "/";
  [params.subcategory || params.parentSlug1, params.parentSlug2].forEach((parentStem, i) => {
    const parentTitle = landingPage.parent_seo_titles[i];
    if (parentStem && parentTitle) {
      parentUrl += `${parentStem}/`;
      items = items.concat({ title: parentTitle, url: parentUrl });
    }
  });

  items = items.concat({ title: landingPage.seo_title, url: trailingSlashIt(location.pathname) });

  return {
    extraClasses: "landing-page-breadcrumbs",
    items
  };
}

export default withRouter(connect(mapStateToProps)(Breadcrumbs));
